<template>
  <div class="diadin">
   <div class="detail-overview">
     <div class="detail-card basic-card">
      <div class="title">
      <div class="title_1">{{ $t('menu.Basicinformation') }}</div>
    </div>
    <div class="cont">
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.OrderNo') }}</div>
        <div>{{ mation[0].po.orderNumber }}</div>

      </div>
    

      <div class="contbox">
        <div class="conttitle">{{ $t('menu.State') }}</div>
        <div>{{ formatStatus(mation[0].po.status) }} </div>
      </div>

      <div class="contbox">
        <div class="conttitle">{{ $t('menu.Distributor') }}</div>
        <div>{{ mation[0].po.dealerName }}</div>
      </div>
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.OrderAmount') }}</div>
        <div style="display: flex;">{{ mation[0].po.orderAmount }} <p style="margin-left: 10px;">{{
          mation[0].po.currencyType }}</p>
        </div>
      </div>
      <div class="contbox">
        <div class="conttitle">{{ $t('menu.Paymentmethod') }}</div>
        {{ jstype(mation[0].po.paymentMethod) }}
        <div>

        </div>
      </div>
      <!-- <div class="contbox">
        <div class="conttitle" >价格条款</div>
        <div>
          {{ mation[0].po.priceTerms }}
        </div>
      </div> -->






    

      

      <div class="contbox">
        <div class="conttitle">{{ $t('menu.FreightMode') }}</div>
        <div>
          {{ formatHy(mation[0].po.shippingMethod) }}
        </div>
      </div>

      <div class="contbox">
        <div class="conttitle">{{ $t('menu.ExpectedShippingdate') }}</div>
        <div>
          {{ formatTime(mation[0].po.shippingDate) }}
          <!-- {{ mation[0].po.shippingDate }} -->
        </div>
      </div>




      <!-- <div class="contbox" style="width: 85%">
        <div class="conttitle" >收货地址</div>
        <div>{{ mation[0].po.address }}</div>
      </div> -->
      <div class="contbox wide-contbox" style="width: 80%;">
        <div class="conttitle">{{ $t('menu.Remarks') }}</div>
        <div style="width: 100%;">
          {{ mation[0].po.userRemarks }}
        </div>
      </div>
      <div class="contbox wide-contbox" style="width: 80%;" v-if="mation[0].po.status==-2">
        <div class="conttitle">{{ $t('menu.Remarksaa') }}</div>
        <div style="width: 100%;">
          {{ mation[0].po.remarks }}
        </div>
      </div>
    </div>
   
   </div>
     <div class="detail-card settlement-card">
      <div class="title">
      <div class="title_1">{{ $t('menu.SettlementInformation') }}</div>
    </div>
  
    <div class="settlement-content">
      <div class="contddt order-total-row">
        <div class="conttitle">{{ $t('menu.OrderAmount') }}</div>
        <div class="primary-amount">{{ formatAmount(mation[0].po.orderAmount) }} {{ ctype(mation[0].po.accTypeId) }}</div>
      </div>
      <div v-if="showVehicleFees" class="fee-details">
    
        <div class="contddt fee-details-row">
          <div class="conttitle">{{ $t('menu.peijianjine') }}</div>
          <div>{{ formatAmount(mation[0].po.partAmount) }} {{ ctype(mation[0].po.accTypeId) }}</div>
        </div>
        <div class="contddt fee-details-row">
          <div class="conttitle">{{ $t('menu.zhesyunshu') }}</div>
          <div>{{ formatAmount(mation[0].po.transportAmount) }} {{ ctype(mation[0].po.accTypeId) }}</div>
        </div>
        <div class="contddt fee-details-row">
          <div class="conttitle">{{ $t('menu.zheshibanyun') }}</div>
          <div>{{ formatAmount(mation[0].po.handlingAmount) }} {{ ctype(mation[0].po.accTypeId) }}</div>
        </div>
        <div class="contddt fee-details-row">
          <div class="conttitle">{{ $t('menu.zheshizhengshu') }}</div>
          <div>{{ formatAmount(mation[0].po.certificateAmount) }} {{ ctype(mation[0].po.accTypeId) }}</div>
        </div>
        <!-- <div class="contddt fee-details-row fee-total-row">
          <div class="conttitle">{{ $t('menu.FeeTotal') }}</div>
          <div>{{ formatAmount(vehicleFeeTotal) }} {{ ctype(mation[0].po.accTypeId) }}</div>
        </div> -->
      </div>

      <div class="summary-group">
        <div class="summary-group-title">{{ $t('menu.PaymentInformation') }}</div>
        <div class="contddt summary-row">
          <div class="conttitle">{{ $t('menu.yueikou') }}</div>
          <div class="success-amount">{{ formatAmount(mation[0].po.discountAmount) }} {{ ctype(mation[0].po.accTypeId) }}</div>
        </div>
        <div class="contddt summary-row">
          <div class="conttitle">{{ $t('menu.zhuanggjine') }}</div>
          <div>{{ formatAmount(transferAmount) }} {{ ctype(mation[0].po.accTypeId) }}</div>
        </div>
      </div>

      <div class="summary-group settlement-status-group">
        <div class="summary-group-title">{{ $t('menu.SettlementStatus') }}</div>
        <div class="contddt summary-row">
        <div class="conttitle">{{ $t('menu.yijiesuanjine') }}</div>
          <div class="success-amount">{{ formatAmount(mation[0].po.settleAmount) }} {{ ctype(mation[0].po.accTypeId) }}</div>
        </div>
        <div class="contddt summary-row">
          <div class="conttitle">{{ $t('menu.daijinsuanjin') }}</div>
          <div class="danger-amount">{{ formatAmount(pendingSettlementAmount) }} {{ ctype(mation[0].po.accTypeId) }}</div>
        </div>
      </div>
    </div>
   
   </div>
   </div>
  
    <div class="title" style=" justify-content: left">
      <div class="title_1">
        {{ $t('menu.ProductDetails') }}
      </div>
    </div>


    <div>
      <el-table  empty-text=" " :data="mation[0].poParts" style="width: 100%" stripe border highlight-current-row
        :cell-style="cellStyle">
        <el-table-column prop="itemNum" :label="$t('menu.ItemNo')" min-width="70"></el-table-column>
        <el-table-column prop="partNumber" :label="$t('menu.PartCode')" min-width="120"></el-table-column>
        <el-table-column prop="partName" :label="$t('menu.PartName')" min-width="160">
          <template slot-scope="scope">
            <div>{{ inle == 'zh' ? scope.row.partName : scope.row.partNameEn }}</div>
          </template>
        </el-table-column>
        
        <el-table-column prop="motorName" :label="$t('menu.VehicleModel')" min-width="120">
          <template slot-scope="scope">
            {{ inle == 'zh' ? scope.row.motorName : scope.row.motorNameEn }}
          </template>
        </el-table-column>
        <el-table-column prop="unitPrice" :label="$t('menu.UnitPrice')" min-width="90"></el-table-column>
          <el-table-column prop="discountUnitPrice" :label="$t('menu.zhekoudanjia')" min-width="100"></el-table-column>
   
        <el-table-column prop="quantity" :label="$t('menu.Quantity')" min-width="80">
          <!-- <template slot-scope="scope">
            {{scope.row.zt|sellstatus}}
          </template> -->
        </el-table-column>
        <el-table-column prop="amount" :label="$t('menu.peijianjine')" min-width="100"></el-table-column>
        <el-table-column v-if="showVehicleFees" :label="$t('menu.zhesyunshu')" min-width="95">
          <template slot-scope="scope">
            {{ formatAmount(lineFeeAmount(scope.row.transportUnitAmount, scope.row.quantity)) }}
          </template>
        </el-table-column>
        <el-table-column v-if="showVehicleFees" :label="$t('menu.zheshibanyun')" min-width="95">
          <template slot-scope="scope">
            {{ formatAmount(lineFeeAmount(scope.row.handlingUnitAmount, scope.row.quantity)) }}
          </template>
        </el-table-column>
        <el-table-column v-if="showVehicleFees" :label="$t('menu.zheshizhengshu')" min-width="95">
          <template slot-scope="scope">
            {{ formatAmount(lineFeeAmount(scope.row.certificateUnitAmount, scope.row.quantity)) }}
          </template>
        </el-table-column>

        
        </el-table-column>
         <el-table-column prop="discountAmount" :label="$t('menu.zhekoujine')" min-width="100"></el-table-column>
        <el-table-column prop="xs" :label="$t('menu.DeliveryProgress')" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.shippedQuantity }}/{{ scope.row.quantity }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="product-box">
      <!-- <div class="status">{{ formatStatus(mation[0].po.status) }}</div>
      <div class="status">商品：{{ mation[0].poParts.length }}</div>
      <div class="status">数量：{{ total }}</div> -->
      <!-- <div class="daochu" @click="exportDetails">{{ $t('menu.Export') }}</div> -->
    </div>

    <div class="agian">
      <el-button v-if="mation[0].po.status == -2 || mation[0].po.status == -1" type="primary" @click="gotoEdit(1)">{{
        $t('menu.Reapply') }}</el-button>
      <!-- <el-button @click="handleEdit">返回</el-button> -->
    </div>



    <div v-if="type==2">
       <div class="title" style=" justify-content: left">
      <div class="title_1">
       {{ $t('menu.OperationRecord')}}
      </div>
    </div>
  <div>
      <el-table  empty-text=" " :data="mation[0].poOperationLogs" style="width: 100%" stripe border highlight-current-row
        :cell-style="cellStyle">
        <el-table-column prop="actionTime" :label="$t('menu.Time')" width="180"></el-table-column>
        <el-table-column prop="actionEvent" :label="$t('menu.OperationContent')" width="180"></el-table-column>
        <el-table-column prop="remarks" :label="$t('menu.Remarks')" width="280">    </el-table-column>
        
        <el-table-column prop="actionUserName" :label="$t('menu.Operator')" width="150"> </el-table-column>
       

      </el-table>
    </div>
    </div>



    <div class="btn-box" v-if="mation[0].po.status == 1">
      <div class="btn blue" @click="openClosePop">{{ $t('menu.Cancel') }}</div>
      <div class="btn blue" @click="gotoEdit(2)">{{ $t('menu.Modify') }}</div>
       <div class="btn blue" v-if="tup!=='2'" @click="openClosePopa">{{ $t('menu.tgl') }}</div>
       <div class="btn blue" v-if="tup!=='2'" @click="openClosePopb">{{ $t('menu.jul') }}</div>
     
      <div class="btn" v-if="mation[0].po.status != 1" @click="goBack">{{ $t('menu.fanhui') }}</div>
    </div>
    <div class="btn-box" v-if="mation[0].po.status == 2">
      <div class="btn blue" @click="openClosePopaca">{{ $t('menu.quxiaofahuoo') }}</div>
      
     
    </div>
    <div class="btn-box" v-if="tup!=='2'">
      <div class="btn blue" v-if="mation[0].po.status==5" @click="erpzd( mation[0])">{{ $t('menu.erpzd') }}</div>
       <!-- <el-button  size="mini" v-if="mation[0].po.status!==1&& mation[0].po.status!==-1&&mation[0].po.status!==-2" @click="erpzd( mation[0])">{{
            $t('menu.erpzd') }}</el-button> -->
    </div>

    <div v-if="mation[0].po.status == 3 || mation[0].po.status == 4">
      <div class="title" style="margin-bottom: 20px; justify-content: left">
        <div class="title_1">
          {{ $t('menu.ShipmentInformation') }}
        </div>
      </div>

      <div>
        <el-table :data="mation[0].poShipments" style="width: 100%" stripe border highlight-current-row
          :cell-style="cellStyle">
          <el-table-column prop="logisticsNumber" :label="$t('menu.ShipmentNo')" width="280"></el-table-column>
          <el-table-column prop="shippedQuantity" :label="$t('menu.Qty')" width="280"></el-table-column>
          <!-- <el-table-column prop="motorName" label="装箱数量"></el-table-column> -->
          <el-table-column prop="shippedTime" :label="$t('menu.ShipmentDate')" width="230">
            <template slot-scope="scope">
              {{ formatDate(scope.row) }}
            </template>
          </el-table-column>
          <!-- <el-table-column prop="quantity" label="备注" width="150"></el-table-column> -->
          <el-table-column>
            <template slot="header" slot-scope="scope">
              <div>{{ $t('menu.Operation') }}</div>
            </template>
            <template slot-scope="scope">
              <div style="display: flex;  width: 100%;">
                <div style="color: #409eff;cursor: pointer;" @click="openDetailsPop">{{ $t('menu.Details') }}</div>
                <!-- <div style="color: #999999;">商业发票</div> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>


 

    <el-dialog :title="$t('menu.DeliveryDetails')" :visible.sync="detailsPop" width="50%">
      <div>
        <el-table :data="mation[0].poParts" style="width: 100%" stripe border highlight-current-row>
          <el-table-column prop="itemNum" :label="$t('menu.ItemNo')" width="80"></el-table-column>
          <el-table-column prop="partNumber" :label="$t('menu.PartCode')" width="180"></el-table-column>
          <el-table-column prop="partName" :label="$t('menu.PartName')"></el-table-column>
          <el-table-column v-if="type == 2" prop="motorName" :label="$t('menu.VehicleModel')"></el-table-column>
           <el-table-column v-if="type == 2" prop="vin" :label="$t('menu.FrameNumber')"></el-table-column>
          <el-table-column prop="quantity" :label="$t('menu.Quantity')" width="130"></el-table-column>
        </el-table>
      </div>
    </el-dialog>



    <el-dialog :title="$t('menu.Tips')" :visible.sync="closePop" width="20%">
      <div style="display: flex;flex-direction: column;align-items: center;justify-content: center;">
        <div style="margin-bottom: 20px;" v-if="inle == 'zh'">确定取消申请?</div>
        <div style="margin-bottom: 20px;" v-if="inle !== 'zh'">Are you sure cancel the application?</div>
        <el-button type="primary" style="width: 120px;" @click="cancel_order">{{ $t('menu.Confirm') }}</el-button>
      </div>
    </el-dialog>
     <el-dialog title="向erp制单" :visible.sync="dialogVisiblea" v-if="dialogVisiblea" width="700px" :before-close="handleClose">
      <div class="ccca" style=" margin: 0 auto">
       <div style="width: 100%;display: flex;    align-items: center;">
        <div style="width: 40%;">
          商户简称：{{ erpform.po.dealerName}}
        </div>
        <div  style="width: 40%;display: flex;align-items: center;">
        
          <div style="width: 150px;">erp商户名称：</div>
           <el-select v-model="erpform.po.address" placeholder="请选择">
            <el-option
              v-for="item in dealist"
              v-if="item.status==1"
              :key="item.id"
              :label="item.erpCompany"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
       </div>
      <div style="width: 100%;display: flex;margin: 10px 0;    align-items: center;">
        <div  style="width: 30%;">
          配件总数：{{ erpform.po.quantity}}
        </div>
        <div  style="width: 30%;">
          订单总额：{{ erpform.po.orderAmount}}{{  erpform.po.currencyType?erpform.po.currencyType:'' }}
        </div>
         <div  style="width: 38%;display: flex;    align-items: center;">
         <div style="width: 60%;">期望发货日期：</div>
         <el-date-picker
      v-model="erpform.po.shippingDate"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择日期">
    </el-date-picker>
        </div>
       </div>
       <div>备注：</div>
       <div style="margin-top: 10px;">
             <el-input
       type="textarea"
       :rows="2"
       placeholder="请输入内容"
       v-model="erpform.po.remarks">
       </el-input>
       </div>
        <div style=" margin: 30px auto" class="er">
          <el-button  type="primary" @click="updata"
            class="er">{{ $t('menu.Confirm') }}</el-button>
       

        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { orderSearch, querytype,listAccType, quxfa,cancelOrder,dealerAreaOfRetailerlist, gbquerytype, exportDetails,myPoUpdate,poAuditOfDealer,submitMyErpOrder } from "../../api/api";

export default {
  data () {
    return {
      closePop: false,
      detailsPop: false,
      dialogVisiblea:false,
      type: 1,
      action: this.$t('menu.CustomerInformation'),
      textarea2: '',
      formInline: {
        title: "",
        status: "",
        startTime: "",
        endTime: "",
        contact: "",
        category: "",
        type: "",
      },
      mation: [],
      ruleForm: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" },
        ],
        region: [
          { required: true, message: "请选择活动区域", trigger: "change" },
        ],
      },
      orderNumber: '',
      jsfs: [],
      prList: [],
      hyList: [],
      ckgb: [],
      inle: 'zh',
      tup:'1',
      erpform:{},
      dealist:[],
      acclist:[]    
    };
  },
  created () {
    let a = sessionStorage.getItem('i18n')
     this.tup = sessionStorage.getItem('platform')
    
       sessionStorage.setItem('xqxq','1')
    this.inle = a
    this.type = this.$route.query.type;
    this.orderNumber = this.$route.query.orderNumber
    this.biao();
    this.querytyp()
    this.jg()
    this.accc()
  },
  computed: {
    showVehicleFees () {
      const order = this.mation[0] && this.mation[0].po
      const orderType = Number(order && order.orderType)
      return orderType === 2 || orderType === 4
    },
    vehicleFeeTotal () {
      const order = this.mation[0] && this.mation[0].po
      if (!order) return 0
      return Number(order.transportAmount || 0) + Number(order.handlingAmount || 0) + Number(order.certificateAmount || 0)
    },
    transferAmount () {
      const order = this.mation[0] && this.mation[0].po
      if (!order) return 0
      return Number(order.orderAmount || 0) - Number(order.discountAmount || 0)
    },
    pendingSettlementAmount () {
      const order = this.mation[0] && this.mation[0].po
      if (!order) return 0
      return this.transferAmount - Number(order.settleAmount || 0)
    },
    total () {
      let total = 0
      let data = this.mation[0].poParts
      data.forEach(i => {
        total += i.quantity
      })
      return total
    },
  },
  // watch: {
  //   mation: {
  //     handler (newVal, old) {
  //       console.log(newVal, old)
  //       if (newVal) {
  //         console.log(this.mation[0].po.shippingDate)
  //         this.mation[0].po.shippingDate = this.mation[0].po.shippingDate.replace('T', ' ')
  //       }
  //     }
  //   }
  // },
  methods: {
    lineFeeAmount (unitAmount, quantity) {
      return Number(unitAmount || 0) * Number(quantity || 0)
    },
    formatAmount (amount) {
      const value = Number(amount || 0)
      return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    feeAmount (amount) {
      return amount !== null && amount !== undefined ? amount : 0
    },
      ccbaopl(e){
    let a = 0
    if(e>0){
      a=e.toFixed(2)
    }
 
    
    return a
   },
       async accc () {
      let param = new URLSearchParams();
      const { data: res } = await listAccType(param)
    this.acclist  = res.data
         

    },
      ctype(e){
      let a = ''
      this.acclist.forEach(z=>{
           if(z.id==e){
              a=z.currencyName
          }
      })
      return a
    },
     async erpzd(e){
      console.log(e);
        let param={}
        const { data: res } = await dealerAreaOfRetailerlist(param,e.po.dealerId)
        console.log(res);
        
        this.dealist=res.rows
      this.erpform=e
      this.dialogVisiblea=true
    },
      handleClose(){
      this.erpform={}
      this.dialogVisiblea=false
    },
     async updata(){

  let param = this.erpform
  this.dealist.forEach(e=>{
    if(param.po.address==e.id){
      param.po.erpCode=e.erpCode
       param.po.erpName=e.erpCompany
        param.po.erpId=e.id
    }
  })
  param.po.shippingDate=param.po.shippingDate.slice(0, 10)+' 00:00:00'
      const { data: res } = await submitMyErpOrder(param)
      if(res.code=='500'){
 this.$message.error(res.msg)
      }else{
        this.$message.success('成功')
          this.handleClose()
       this.biao()
      }
      
  
    },
    exportDetails () {
      // let id =
      // exportDetails().then (r => {
      //   console.log(r)
      // })
    },
    formatDate (row) {
      let str = row.shippedTime.slice(0, 10)
      return str
    },
    formatHy (item) {
      let str = ''
      this.hyList.forEach(i => {
        if (i.dictValue == item) {
          str = i.dictLabel
        }
        if (i.dictValue == item && this.inle !== 'zh') {
          str = i.dictLabelEn
        }
      })
      return str
    },
    jg () {
      let param = new URLSearchParams();
      querytype(param, 't_po_price_item').then(r => {
        if (r.data.code == 200) {
          this.prList = r.data.data
        }
      })
      querytype(param, 't_po_shipment_method').then(r => {
        if (r.data.code == 200) {
          this.hyList = r.data.data
        }
      })

      querytype(param, 'sys_dealer_area').then(r => {
        if (r.data.code == 200) {
          console.log(123, r)
          this.ckgb = r.data.data
        }
      })
    },
    formatCKBG (val) {
      let str = ''
      this.ckgb.forEach(item => {
        if (item.dictValue == val) {
          if (this.inle == 'zh') {
          str = item.dictLabel
        } else {
         str = item.dictLabelEn
        }
        }

      })
      return str
    },
    formatTime (time) {
      if (time) {
        let str = time.replace('T', ' ')
        return str.slice(0, 10)
      } else {
        let a = ''
        if (this.inle == 'zh') {
          a = '暂无数据'
        } else {
          a = 'No data available yet'
        }
        return a
      }
    },
    async gbquerytype () {
      let param = new URLSearchParams();
      const { data: res } = await gbquerytype(param, 'sys_dealer_area', this.uesrid);
      this.gb = res.data
    },
    cancel_order () {
      let param = new URLSearchParams();
      cancelOrder(
        param,
        this.mation[0].po.id,
        ' '
      ).then(r => {
        if (r.data.code == 200) {
          this.$message.success('取消成功')
          this.closePop = false
          this.$router.back()
        } else {
          this.$message.error('取消失败')
          this.closePop = false

        }
      })
    },
    async querytyp () {
      let param = new URLSearchParams();
      const { data: res } = await querytype(
        param,
        't_po_payment_method'
      );
      this.jsfs = res.data;
    },
    jstype (e) {
      let c = ''
      let a = this.jsfs
      a.forEach(z => {
        if (e == z.dictValue && this.inle == 'zh') {
          c = z.dictLabel
        }
        if (e == z.dictValue && this.inle !== 'zh') {
          c = z.dictLabelEn
        }
      })
      return c
    },
    openDetailsPop () {
      this.detailsPop = true
    },
    formatStatus (status) {
      if (status == -2) {
        return this.$t('menu.Rejected')
      } else if (status == -1) {
        return this.$t('menu.Cancelled')
      } else if (status == 0) {
        return '待支付'
      } else if (status == 1) {
        return this.$t('menu.PendingReview')
      } else if (status == 2) {
        return this.$t('menu.PendingShipment')
      } else if (status == 3) {
        return this.$t('menu.UnderDelivery')
      } else if (status == 4) {
        return this.$t('menu.Completed')
      }else if (status == 5) {
        return this.$t('menu.daizhid')
      }
    },
    gotoEdit (type) {
      if (type == 2) {
        sessionStorage.setItem('name', '修改订单')
        sessionStorage.setItem('pageType', 'edit')
      } else if (type == 1) {

        sessionStorage.setItem('name', this.$t('menu.Reapply'))
      }
      this.$router.push({
        path: "/ordercontenta",
        query: {
          orderNumber: this.orderNumber,
          // type
        },
      })
    },
    cellStyle ({ row, column }) {
      return "height:50px;text-align:center;"
    },
    confirmCancel () {
      this.closePop = false
    },
    openClosePop () {
      this.closePop = true
    },
      async openClosePopaca(){
    
       let param = new URLSearchParams()
       let a = this.mation[0].po.id
      const { data: res } = await quxfa(
        param,
        a,
        ''
      )
      console.log(res.data);
      
      if (res.data == true) {
          this.$message.success('success')
          this.$router.back()
        } else {
          this.$message.error(res.message)
          return
        }
    },
   async openClosePopa(){
    
       let param = new URLSearchParams()
       let a = this.mation[0].po.id
      const { data: res } = await poAuditOfDealer(
        param,
        true,
        a
      )
      console.log(res.data);
      
      if (res.data == true) {
          this.$message.success('审核完成')
          this.$router.back()
        } else {
          this.$message.error(res.message)
          return
        }
    },
    async openClosePopb(){
         let param = new URLSearchParams()
       let a = this.mation[0].po.id
      const { data: res } = await poAuditOfDealer(
        param,
        false,
        a
      )
      console.log(res.data);   
      if (res.data == true) {
          this.$message.success('拒绝完成')
          this.$router.back()
        } else {
          this.$message.error(res.message)
          return
        }
     },
    async biao () {
      let param = new URLSearchParams();
      let orderNumber = this.orderNumber
      const { data: res } = await orderSearch(param, orderNumber);
      console.log(res)
    
      this.mation=[]
      this.mation.push(res.data)
      // this.totale = res.data.total;
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm (formName) {
      this.$refs[formName].resetFields();
    },
    act (e) {
      this.action = e;
    },
    handleEdit (index, row) {
      this.$router.back()
    },
    goBack () {
      this.$router.back()
    }
  },
};
</script>

<style lang="less" scoped>
.diadin {
  width: 100%;
  min-height: 100%;

  padding: 24px;
  box-sizing: border-box;
  color: #303746;
  overflow-x: hidden;
}

.detail-overview {
  display: grid;
  grid-template-columns: minmax(0, 1.65fr) minmax(340px, .85fr);
  gap: 20px;
  align-items: stretch;
}

.detail-card {
  min-width: 0;
  height: 100%;
  background-color: #fff;
  border: 1px solid #edf0f5;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(32, 45, 64, .05);
  overflow: hidden;
}
.contddt{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  font-size: 14px;
}

.fee-details {
  padding: 18px 0 14px;
  border-top: 1px solid #edf0f5;
}

.fee-details-title {
  margin-bottom: 12px;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}

.fee-details-row {
  min-height: 32px;
}

.fee-total-row {
  margin-top: 6px;
  padding-top: 10px;
  border-top: 1px dashed #e4e8ee;
  font-weight: 600;
}

.settlement-content {
  padding: 6px 24px 24px;
}

.order-total-row {
  min-height: 58px;
}

.primary-amount {
  color: #2878ff;
  font-size: 20px;
  font-weight: 700;
}

.summary-group {
  padding: 18px 0 12px;
  border-top: 1px solid #edf0f5;
}

.summary-group-title {
  margin-bottom: 10px;
  color: #303133;
  font-size: 14px;
  font-weight: 600;
}

.summary-row {
  min-height: 34px;
}

.success-amount {
  color: #15b86a;
  font-weight: 600;
}

.danger-amount {
  color: #f04444;
  font-weight: 600;
}
.title {
  width: 100%;
  border-bottom: 1px solid #edf0f5;
  padding: 20px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
}

.title_1 {
  padding-left: 12px;
  border-left: 4px solid #2878ff;
  color: #202735;
  font-size: 17px;
  font-weight: 600;
}

.cont {
  display: flex;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 22px 28px;
  padding: 24px;
      flex-wrap: wrap;
}

.contbox {
  width: 20%;
  min-width: 0;
  margin-top: 0;
  color: #303746;
  font-size: 14px;
  line-height: 1.6;
}

.wide-contbox {
  grid-column: 1 / -1;
}

.contbox1 {

  width: 30%;
}


/deep/.el-form-item__content {
  width: 100%;
}

/deep/.el-select {
  width: 95%;
}

/deep/.el-table th.is-leaf {
  text-align: center;
  background-color: #d7d7d7;
}

.actio {
  color: #409eff;
}

.product-box {
  margin-top: 20px;
  display: flex;

  div {
    margin-right: 20px;
  }

  .daochu {
    color: #409eff;
  }
}

.btn-box {
  margin-top: 80px;
  display: flex;

  div {
    margin-right: 20px;
  }

  .blue {
    border: 0 !important;
    background-color: #409eff;
    color: #fff !important;
  }

  .btn {
    cursor: pointer;
    border: 1px solid #eee;
    width: 100px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }

}
.conttitle {
  width: auto;
  text-align: left;
  margin-bottom: 7px;
  color: #909399;
}

.settlement-card .conttitle {
  margin-bottom: 0;
}
/deep/.el-table th.is-leaf {
  text-align: left;
  background-color: #f7f9fc;
  color: #303746;
  font-weight: 600;
}

/deep/.el-table__row {
  td {
    text-align: left !important;
  }
}

.popbtn {
  width: 200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.cell-style {
  display: flex;
  align-items: center;
  justify-content: center;
}

.agian {
  margin-top: 20px;
}

.diadin > .title,
.diadin > div > .title {
  margin-top: 20px;
 
  border: 1px solid #edf0f5;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 4px 16px rgba(32, 45, 64, .04);
}

/deep/.el-table {
  color: #4f596b;
}

/deep/.el-table--border,
/deep/.el-table--group {
  border-color: #e6eaf0;
}

/deep/.el-table td,
/deep/.el-table th.is-leaf {
  border-color: #e6eaf0;
}

@media (max-width: 1200px) {
  .detail-overview {
    grid-template-columns: 1fr;
  }

  .settlement-card {
    width: 100%;
  }
}

@media (max-width: 760px) {
  .diadin {
    padding: 16px;
  }

  .cont {
    grid-template-columns: 1fr;
  }

  .wide-contbox {
    grid-column: auto;
  }
}
</style>
